import SubTitle from "Theme/SubTitle";
import { useState, useEffect } from "react";
import axios from "axios";
import Thanks from "./Thanks";

const serviceForm = {
  serialnumber: "",
  symkar: "",
  computername: "",
  name: "",
  name2: "",
  contactperson: "",
  phone: "",
  email: "",
  lokalizacja: "",
  lokalizacjaosobakontaktowa: "",
  lokalizacjanumertelefonu: "",
  street: "",
  postcode: "",
  city: "",
  description: ""
}


const requiredFields = [
  "name", "name2", "phone", "email", "lokalizacja",
  "lokalizacjaosobakontaktowa", "lokalizacjanumertelefonu",
  "postcode", "city", "street", "description"
];

const validateField = (name, rawValue) => {
  const value = rawValue.trim();
  if (requiredFields.includes(name) && !value) return "To pole jest wymagane.";
  if (name === "email" && !/^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/.test(value)) {
    return "Podaj poprawny adres e-mail, np. jan@example.pl.";
  }
  if (["phone", "lokalizacjanumertelefonu"].includes(name)) {
    const digits = value.replace(/\D/g, "");
    if (!/^\+?[0-9 ()-]+$/.test(value) || digits.length < 9 || digits.length > 15) {
      return "Podaj numer telefonu zawierający od 9 do 15 cyfr, opcjonalnie z prefiksem +.";
    }
  }
  if (name === "postcode" && !/^\d{2}-\d{3}$/.test(value)) {
    return "Podaj kod pocztowy w formacie 00-000.";
  }
  return "";
};

const ReportToService = ({ computer }) => {

  const [errors, setErrors] = useState({});
  const [isSending, setIsSending] = useState(false);
  const [sendError, setSendError] = useState("");
  const [inputs, setInputs] = useState(serviceForm);
  const [showThanks, setThanks] = useState(false);
  const [failedSend, setFailedSend] = useState(true);
  const [numerZlecenia, setNumerZlecenia] = useState("")
  const [errorDetails, setErrorDetails] = useState("");

  useEffect(() => {
    setInputs(values => ({ ...values, serialnumber: computer.sn }));
    setInputs(values => ({ ...values, computername: computer.name }));
    setInputs(values => ({ ...values, symkar: computer.symkar }));
  }, [computer])


  const sendToService = (dataToSend) => {
    setIsSending(true);
    setSendError("");
    return axios
      .post(`https://support.ntt.pl/proxy.php`, {
        method: "send",
        data: dataToSend

      })
      .then(({ data }) => {
        if (data.data.status === "ERROR") {
          setErrorDetails(data.data.error)
          setThanks(true);
          setFailedSend(false);
        } else {
          setThanks(true);
          setFailedSend(false);
          setNumerZlecenia(data.data.numerZlecenia);
        }

      })
      .catch((error) => {
        console.error(error);
        setSendError("Nie udało się wysłać zgłoszenia. Spróbuj ponownie.");
      })
      .finally(() => setIsSending(false));
  };

  const handleSendToService = (event) => {
    event.preventDefault();

    if (isSending) return;
    const normalized = Object.fromEntries(
      Object.entries(inputs).map(([name, value]) => [name, String(value ?? "").trim()])
    );
    const nextErrors = {};
    requiredFields.forEach(name => {
      const error = validateField(name, normalized[name]);
      if (error) nextErrors[name] = error;
    });
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) {
      event.currentTarget.elements.namedItem(Object.keys(nextErrors)[0])?.focus();
      return;
    }
    sendToService(normalized);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs(values => ({ ...values, [name]: value }));
    if (Object.prototype.hasOwnProperty.call(errors, name)) {
      setErrors(previous => ({ ...previous, [name]: validateField(name, value) }));
    }
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    setErrors(previous => ({ ...previous, [name]: validateField(name, value) }));
  };

  const fieldProps = (name) => ({
    id: name,
    required: true,
    onBlur: handleBlur,
    "aria-invalid": Boolean(errors[name]),
    "aria-describedby": errors[name] ? `${name}-error` : undefined,
  });

  const fieldError = (name) => errors[name] ? (
    <p id={`${name}-error`} role="alert" className="mt-1 text-sm text-red-600">
      {errors[name]}
    </p>
  ) : null;

  return (
    <>
      <div>
        <SubTitle>
          Zgłoś komputer do naprawy:
        </SubTitle>

      </div>
      {failedSend && (
        <>
          <div>
            <form noValidate className="w-full" onSubmit={handleSendToService}>
              <div className="max-w-4xl mx-auto p-6 space-y-6 bg-gray-100">
                {/* ZGŁASZAJĄCY */}
                <div className="border p-4 bg-white">
                  <h2 className="text-lg font-bold border-b mb-4">ZGŁASZAJĄCY:</h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="name" className="block text-sm font-semibold mb-1">NAZWA ZGŁASZAJĄCEGO</label>
                      <input type="text" name="name" value={inputs.name} onChange={handleChange} className="w-full border rounded px-2 py-1" {...fieldProps("name")} />
                      {fieldError("name")}
                    </div>
                    <div>
                      <label htmlFor="name2" className="block text-sm font-semibold mb-1">IMIĘ/NAZWISKO</label>
                      <input type="text" name="name2" value={inputs.name2} onChange={handleChange} className="w-full border rounded px-2 py-1" {...fieldProps("name2")} />
                      {fieldError("name2")}
                    </div>
                    <div>
                      <label htmlFor="phone" className="block text-sm font-semibold mb-1">NUMER TELEFONU</label>
                      <input type="tel" name="phone" value={inputs.phone} onChange={handleChange} className="w-full border rounded px-2 py-1" {...fieldProps("phone")} />
                      {fieldError("phone")}
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-semibold mb-1">ADRES EMAIL</label>
                      <input type="email" name="email" value={inputs.email} onChange={handleChange} className="w-full border rounded px-2 py-1" {...fieldProps("email")} />
                      {fieldError("email")}
                    </div>
                  </div>
                </div>

                {/* LOKALIZACJA URZĄDZENIA */}
                <div className="border p-4 bg-white">
                  <h2 className="text-lg font-bold border-b mb-4">LOKALIZACJA URZĄDZENIA:</h2>
                  <div className="mb-4">
                    <label htmlFor="lokalizacja" className="block text-sm font-semibold mb-1">NAZWA INSTYTUCJI</label>
                    <input type="text" name="lokalizacja" value={inputs.lokalizacja} onChange={handleChange} className="w-full border rounded px-2 py-1" {...fieldProps("lokalizacja")} />
                      {fieldError("lokalizacja")}
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label htmlFor="lokalizacjaosobakontaktowa" className="block text-sm font-semibold mb-1">OSOBA KONTAKTOWA</label>
                      <input type="text" name="lokalizacjaosobakontaktowa" value={inputs.lokalizacjaosobakontaktowa} onChange={handleChange} className="w-full border rounded px-2 py-1" {...fieldProps("lokalizacjaosobakontaktowa")} />
                      {fieldError("lokalizacjaosobakontaktowa")}
                    </div>
                    <div>
                      <label htmlFor="lokalizacjanumertelefonu" className="block text-sm font-semibold mb-1">NUMER TELEFONU</label>
                      <input type="tel" name="lokalizacjanumertelefonu" value={inputs.lokalizacjanumertelefonu } onChange={handleChange} className="w-full border rounded px-2 py-1" {...fieldProps("lokalizacjanumertelefonu")} />
                      {fieldError("lokalizacjanumertelefonu")}
                    </div>
                    <div>
                      <label htmlFor="postcode" className="block text-sm font-semibold mb-1">KOD POCZTOWY</label>
                      <input type="text" name="postcode" value={inputs.postcode} onChange={handleChange} className="w-full border rounded px-2 py-1" {...fieldProps("postcode")} />
                      {fieldError("postcode")}
                    </div>
                    <div>
                      <label htmlFor="city" className="block text-sm font-semibold mb-1">MIEJSCOWOŚĆ</label>
                      <input type="text" name="city" value={inputs.city} onChange={handleChange} className="w-full border rounded px-2 py-1" {...fieldProps("city")} />
                      {fieldError("city")}
                    </div>
                  </div>
                  <div>
                    <label htmlFor="street" className="block text-sm font-semibold mb-1">ULICA</label>
                    <input type="text" name="street" value={inputs.street} onChange={handleChange} className="w-full border rounded px-2 py-1" {...fieldProps("street")} />
                      {fieldError("street")}
                  </div>
                </div>

                {/* OPIS USTERKI */}
                <div className="border p-4 bg-white">
                  <h2 className="text-lg font-bold border-b mb-4"><label htmlFor="description">OPIS USTERKI:</label></h2>
                  <textarea {...fieldProps("description")} className="w-full border rounded px-2 py-1 h-32 resize-none" name="description" value={inputs.description} onChange={handleChange}></textarea>
                  {fieldError("description")}
                </div>

                <div className="border p-4 bg-white">
                 
                  {sendError && <p role="alert" className="mb-2 text-sm text-red-600">{sendError}</p>}
                  <input type="submit" disabled={isSending} value={isSending ? "Wysyłanie…" : "Wyślij"} />
                </div>
              </div>
            </form>
          </div>
          <div>

          </div>



        </>
      )}

      <div>
        {showThanks && (
          <Thanks errorDetails={errorDetails} numerZlecenia={numerZlecenia} sn={computer.sn} model={computer.name} status={failedSend} />
        )}
      </div>
    </>

  );
};


export default ReportToService;
